import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-101">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-102">
          <div data-id="element-103">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-104">
              CateringCareers
            </h3>
            <p className="text-gray-400" data-id="element-105">
              Connecting talented professionals with the best opportunities in
              the catering industry.
            </p>
            <div className="flex space-x-4 mt-6" data-id="element-106">
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-107">
                <Facebook size={20} data-id="element-108" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-109">
                <Twitter size={20} data-id="element-110" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-111">
                <Instagram size={20} data-id="element-112" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-113">
                <Linkedin size={20} data-id="element-114" />
              </a>
            </div>
          </div>
          <div data-id="element-115">
            <h4 className="text-white font-semibold mb-4" data-id="element-116">For Job Seekers</h4>
            <ul className="space-y-2" data-id="element-117">
              <li data-id="element-118">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-119">
                  Browse Jobs
                </a>
              </li>
              <li data-id="element-120">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-121">
                  Create Profile
                </a>
              </li>
              <li data-id="element-122">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-123">
                  Job Alerts
                </a>
              </li>
              <li data-id="element-124">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-125">
                  Career Resources
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-126">
            <h4 className="text-white font-semibold mb-4" data-id="element-127">For Employers</h4>
            <ul className="space-y-2" data-id="element-128">
              <li data-id="element-129">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-130">
                  Post a Job
                </a>
              </li>
              <li data-id="element-131">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-132">
                  Browse Candidates
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-134">
                  Pricing Plans
                </a>
              </li>
              <li data-id="element-135">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-136">
                  Recruitment Solutions
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-137">
            <h4 className="text-white font-semibold mb-4" data-id="element-138">Company</h4>
            <ul className="space-y-2" data-id="element-139">
              <li data-id="element-140">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-141">
                  About Us
                </a>
              </li>
              <li data-id="element-142">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-143">
                  Contact
                </a>
              </li>
              <li data-id="element-144">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-145">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-146">
                <a href="#" className="text-gray-400 hover:text-white transition" data-id="element-147">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400" data-id="element-148">
          <p data-id="element-149">
            &copy; {new Date().getFullYear()} CateringCareers. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}